import { previewScrollbar } from 'shared-widget-components/src/components/preview/previewScrollbar';
import { CDNImage } from 'shared-widget-components/src/components/CDNImage/CDNImage';
import { OpeningTextWidgetState } from '../models/OpeningTextWidgetState';
import { OpeningTextCard } from './OpeningText/OpeningTextCard';

/**
 * this component is used to render the opening text widget
 */
export const OpeningTextComponent = (props: OpeningTextWidgetState) => {
  // position the card with the text based on the alignment
  const alignmentClass = `flex min-[350px]:flex-col sm:flex-row min-[350px]:justify-center min-[350px]:items-center ${
    props.aligment === 'left' ? 'sm:justify-start' : 'sm:justify-end'
  } relative max-w-[1240px] mx-auto w-full p-6`;

  // change the image styling based on the type
  const imageChangerByType = () => {
    if (props.type === 1) return { className: '' };
    if (props.type === 2 && props.aligment === 'left') return { className: 'sm:pl-[100px]' };
    if (props.type === 2 && props.aligment === 'right') return { className: 'sm:pr-[100px]' };
    else return { className: '' };
  };

  const imageClass = imageChangerByType();

  return (
    <div
      className='flex justify-center relative min-[350px]:items-start sm:items-center mx-auto w-full px-4 sm:px-8 previewScrollbar h-full min-[350px]:overflow-y-auto sm:overflow-hidden min-[350px]:py-4 md:py-6 lg:py-10'
      style={{ background: props.backgroundColor }}
    >
      <style>{previewScrollbar}</style>
      <div className={alignmentClass}>
        {props.image && props.image[0] && props.image[0].url && (
          <CDNImage
            src={props.image[0].url}
            alt={props.image[0].alt}
            imageWidth={1240}
            imageHeight={698}
            mobileWidth={620}
            mobileHeight={349}
            fit='crop'
            className={`rounded min-[350px]:pl-0 min-[350px]:pr-0  ${imageClass?.className}`}
          />
        )}
        <OpeningTextCard props={props} />
      </div>
    </div>
  );
};
